import React from 'react'
import PropTypes from 'prop-types'

import Checkbox from '../../../components/Form/Checkbox'

import useIsInternalAdCreation from '../../../features/hooks/internalAdHooks/useIsInternalAdCreation'

import { IS_QUARANTINE } from '../../reusableFields'

const AdQuarantineField = ({ formik }) => {
  const { values, setFieldValue } = formik

  const isInternalAdCreation = useIsInternalAdCreation()

  // when not internal ad creation by default, add ability to select it manually(this happens for controller users)
  return (
    !isInternalAdCreation && (
      <Checkbox
        id="checkbox_set_quarantine_ad_creation"
        title="Send for approval"
        checked={values[IS_QUARANTINE]}
        onCheck={() => setFieldValue(IS_QUARANTINE, !values[IS_QUARANTINE])}
      />
    )
  )
}

AdQuarantineField.propTypes = {
  formik: PropTypes.object.isRequired
}

export default AdQuarantineField
